import React from "react";
import styled from "styled-components";
import { TextButton } from "../buttons/CommonButton";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";

const DialogContainer = styled.div`
	position: fixed;
	z-index: 12;
	left: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	overflow: auto;
	background-color: rgba(0, 0, 0, 0.4);
`;

const ModalDialogContent = styled.div`
	position: relative;
	min-width: 280px;
	max-width: 560px;
	max-height: ${(props) => (props.isOpen ? "400px" : "0px")};
	padding: ${(props) => (props.isOpen ? "24px" : "0px 24px")};
	overflow: hidden;
	color: var(--color-on-surface);
	background: var(--color-surface-container-high);
	border-radius: 28px;
	text-align: ${(props) => (props.centerAlign ? "center" : "left")};
	transition: 0.3s;
`;

const ModalDialogHeader = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: ${(props) => (props.centerAlign ? "center" : "left")};
	gap: 16px;
	margin-bottom: 16px;

	span {
		color: ${(props) => props.iconTheme};
	}
`;

const ModalDialogButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
	justify-content: flex-end;
	align-items: center;
	margin-top: 24px;
`;

export default class ModalDialogComponent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			isDialogOpen: false,
			theme: props.theme || "var(--color-secondary)",
		};

		this.open = this.open.bind(this);
		this.close = this.close.bind(this);
	}

	open() {
		this.setState({ isOpen: true });
		setTimeout(() => {
			this.setState({ isDialogOpen: true });
		}, 10);
	}

	close() {
		this.setState({ isDialogOpen: false });
		setTimeout(() => {
			this.setState({ isOpen: false });
		}, 300);
	}

	render() {
		return this.state.isOpen
			? createPortal(
					<DialogContainer
						aria-modal="true"
						role="dialog"
						onClick={() => this.close()}
					>
						<ModalDialogContent
							isOpen={this.state.isDialogOpen}
							centerAlign={this.props.icon !== null}
							onClick={(e) => e.stopPropagation()}
						>
							<ModalDialogHeader
								centerAlign={this.props.icon !== null}
								iconTheme={this.state.theme}
							>
								{this.props.icon !== null && (
									<span className="material-symbol fill">
										{this.props.icon}
									</span>
								)}
								<h2 className="headline-small">
									{this.props.title}
								</h2>
							</ModalDialogHeader>
							{this.props.children}
							<ModalDialogButtonContainer>
								{this.props.cancelButton && (
									<TextButton
										theme={
											this.props.cancelButton.theme ||
											"primary"
										}
										text={this.props.cancelButton.text}
										onClick={
											this.props.cancelButton.onClick
										}
									/>
								)}
								{this.props.confirmButton && (
									<TextButton
										theme={
											this.props.cancelButton.theme ||
											"primary"
										}
										text={this.props.confirmButton.text}
										onClick={
											this.props.confirmButton.onClick
										}
									/>
								)}
							</ModalDialogButtonContainer>
						</ModalDialogContent>
					</DialogContainer>,
					document.body
			  )
			: null;
	}
}

ModalDialogComponent.propTypes = {
	title: PropTypes.string.isRequired,
	icon: PropTypes.string,
	children: PropTypes.node,
	cancelButton: PropTypes.shape({
		theme: PropTypes.string,
		text: PropTypes.string.isRequired,
		onClick: PropTypes.func.isRequired,
	}),
	confirmButton: PropTypes.shape({
		theme: PropTypes.string,
		text: PropTypes.string.isRequired,
		onClick: PropTypes.func.isRequired,
	}),
	theme: PropTypes.string,
};

ModalDialogComponent.defaultProps = {
	icon: null,
	children: null,
	cancelButton: null,
	confirmButton: null,
	theme: "var(--color-secondary)",
};
